import React, { useEffect } from "react";
import { Formik, Form } from "formik";
import { TextInputComponent } from "../../../../common/components";
import './filter-options-text.scss';

const CountryFilter: any = (
  props: any
) => {
  const { country, handleCountryChange, isCountryEnabled, countryError } = props
  useEffect(() => {
    if (!isCountryEnabled) {
      handleCountryChange({ target: { value: "", name: "country" } } as any, "country");
    }
  }, [isCountryEnabled]);
  return (
    <div className="filter-options-text-wrapper">
      <Formik
        initialValues={{
          country: country,
        }}
        onSubmit={(values) => {
          console.log("Form Submitted with values:", values);
        }}
      >
        <Form className="filter-options">
          <TextInputComponent
            type="text"
            fieldName="country"
            placeholder="Enter Country"
            optional={false}
            disabled={false}
            value={country}
            onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
              handleCountryChange(e, "country")
            }
          />
          {countryError && <div className="error-text">{countryError}</div>}
        </Form>
      </Formik>
    </div>

  );
};
export default CountryFilter;